import { useCallback } from "react";
import { useSelector } from "react-redux";
import { selectCurrency } from "../store/reducers/countrySlice";
import { getCurrencySymbol } from "../config/countries";
import { formatMoney } from "../utils/money";

/**
 * Devise de contexte (pays d'activité) et formateur associé.
 *
 * La devise d'une transaction l'emporte toujours : format(montant, accord.currency)
 * n'utilise la devise de contexte que si accord.currency est absent.
 */
const useCurrency = () => {
    const currency = useSelector(selectCurrency);
    const referential = useSelector(state => state.country?.currencyReferential);

    const format = useCallback(
        (amount, entityCurrency) => formatMoney(amount, entityCurrency || currency),
        [currency]
    );

    // Symbole du référentiel backend quand il est chargé, table locale sinon.
    const symbol = useCallback(
        entityCurrency => {
            const code = entityCurrency || currency;
            const backend = Object.values(referential || {}).find(entry => entry.currency === code);
            return backend?.symbol ?? getCurrencySymbol(code);
        },
        [currency, referential]
    );

    return { currency, format, symbol };
};

export default useCurrency;
